<template>
  <div id="sportbook" data-bto-app>
    <router-view />
    <div v-show="false">
      <svg id="barcode" style="max-width: 100%"></svg>
    </div>
  </div>
</template>

<script>
  import { EventBus } from './services/event-bus-service';
  import RouterService from './services/router-service';
  import { userLoggedIn } from '@bto-services/user';
  import GetBonusRulesRequestService from '@bto-services/api/shared/get-bonus-rules-request-service';
  import { setAccumulatorBonus } from '@bto-services/betslip-core';

  export default {
    name: 'App',
    data() {
      return {
        x: 10
      };
    },
    created() {
      // set start layout
      RouterService.setPath(this.$router.currentRoute);
      let unwatch = this.$store.watch((state) => {
        if (state.LayoutModule.layouts.length > 0 && typeof unwatch === 'function') {
          RouterService.setPath(this.$router.currentRoute);
          unwatch();
        }
      });

      // call API to get bonus rules for anonymus users
      if (!userLoggedIn()) {
        new GetBonusRulesRequestService().execute((resp) => {
          if (resp.data) {
            setAccumulatorBonus(resp.data);
          }
        });
      }
    },
    watch: {
      $route(to) {
        // on route change update layout
        RouterService.setPath(to);
        // hide odd tooltip on route change in case it is visible
        EventBus.$emit('hideoddmarketpopup');
      },
    },
  };
</script>

<style>
  @import url("https://fonts.googleapis.com/css?family=Roboto+Condensed:400,700&amp;subset=cyrillic&display=swap");
  @import url("bto-design/SB/css/style.css");
  @import url("bto-design/SB/css/betslip.css");
  #sportbook[data-bto-app] {
    visibility: hidden;
    display: block;
  }
</style>